import { render, staticRenderFns } from "./ConnectBitfinex.vue?vue&type=template&id=179e8b3c&"
import script from "./ConnectBitfinex.vue?vue&type=script&lang=js&"
export * from "./ConnectBitfinex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports